import type { RouteRecordRaw } from 'vue-router'

const projectRoutes: RouteRecordRaw[] = [
  {
    path: 'projects',
    component: () => import('@/views/project/ProjectLayout.vue'),
    meta: { permission: 'project:record:view' },
    children: [
      {
        path: '',
        name: 'projects',
        component: () => import('@/views/project/ProjectList.vue'),
        meta: { permission: 'project:record:view' }
      },
      {
        path: 'risk-board',
        name: 'project-risk-board',
        component: () => import('@/views/project/RiskChangeBoard.vue'),
        meta: {
          permission: {
            any: ['project:risk:view', 'project:change:view']
          }
        }
      },
      {
        path: ':id',
        name: 'project-detail',
        component: () => import('@/views/project/ProjectDetail.vue'),
        meta: { permission: 'project:record:view' }
      }
    ]
  }
]

export default projectRoutes
